import { dehydrate } from '@tanstack/react-query'

import { fetchPageData } from 'src/lib/react-query/api'
import { getQueryClient } from 'src/lib/react-query/client'
import { getHeaderDataQuery, queryKeys } from 'src/lib/react-query/queries'
import AdFormatsPage from 'src/components/pages/AdFormatsPage'
import Header from 'src/components/navigation/header/Header'
import { type HeaderData } from 'src/components/navigation/header/headerHelpers'
import { parseErrorToServerFunction } from 'src/lib/api'

import type { GetServerSideProps } from 'next'
import type { JsonApiCMSAdFormatsPage } from 'src/types/adsales/models/cmsPages'

const Slug = ({ res, headerData }: { res: JsonApiCMSAdFormatsPage; headerData: HeaderData }) => {
  return (
    <>
      <Header headerData={headerData} />
      <AdFormatsPage res={res} />
    </>
  )
}
export default Slug

export const getServerSideProps: GetServerSideProps = async ({ params }) => {
  const slugArray = params?.slug as string[]
  const slug = 'ad-formats/' + slugArray[0]

  const queryClient = getQueryClient()

  await queryClient.prefetchQuery({
    queryKey: queryKeys.menu,
    queryFn: getHeaderDataQuery
  })
  const headerData = queryClient.getQueryData(queryKeys.menu)

  const { data, isError, error } = await fetchPageData<JsonApiCMSAdFormatsPage>(slug)

  if (isError && error) {
    return parseErrorToServerFunction(error)
  }

  return {
    props: {
      res: data,
      slug: slugArray?.[0] || 'home',
      headerData,
      dehydratedState: dehydrate(queryClient)
    }
  }
}
